import { FormStep, StepType, StepTypeWithIndex } from '../types';

export function setCurrentStepByHash(
  hash: string,
  options: FormStep[],
  setCurrentStep: (step: StepTypeWithIndex) => void
) {
  if (!hash) return;
  const newStep = options.find((opt) => `#${opt.step}` === hash);

  if (newStep) {
    setCurrentStep({
      type: newStep.type as StepType,
      index: Number(newStep.step),
      step: newStep.step,
    });
  }
}
